<template>
    <div class="o-page__inner"
        :class="{ '-embedded': embedded }"
        :data-component-name="$options.name"
    >
		<div class="o-form -two-columns">
			<div class="o-page__loading" v-if="$apollo.loading">
                <q-spinner
                    color="white"
                    size="1em"
                />
                Chargement en cours
            </div>
            <div class="o-row -gutter-xs">
                <div class="o-col w-1/3">
                    <div class="o-col__inner -sticky">
                        <h1 class="o-form__title" v-if="!embedded">Attributs</h1>
                        <h2 class="o-form__title q-mt-lg q-mb-sm" v-else>Attributs</h2>
                        <Listbox
                            :embedded="embedded"
                            v-bind:listbox="listbox"
                            @selected="setSelected"
                            @set-new-item="setNewItem"
                            @delete-item="deleteItem($event)"
                            @duplicate-item="duplicateItem($event)"
                            :deletedShowable="true"
                            @set-show-deleted="showDeleted = $event"
                            :showDeleted="showDeleted"
                            :isSmall="isSmall"
                        />
                    </div>
                </div>

                <div class="o-col w-2/3">
                    <form
                        @submit.prevent="saveItem(form)"
                        autocomplete="off"
                    >
                        <fieldset class="o-form__inner">
                            <!-- <div class="o-form__title -save-button">
                                <button type="submit" class="o-button -lg" :loading="$apollo.loading" color="primary"  v-if="form.id">
                                    Sauvegarder
                                    <q-icon name="save" class="o-ico -right" />    
                                </button>
                                <button type="submit" class="o-button -lg" :loading="$apollo.loading" color="primary"  v-else>
                                    Ajouter
                                    <q-icon name="save" class="o-ico -right" />    
                                </button>
                            </div> -->
                            <!-- <h1 class="o-form__title">Attributs</h1> -->
                            <input
                                type="hidden"
                                name="id"
                                v-model="form.id"
                                v-if="form.id"
                            >
                            <input
                                type="hidden"
                                name="customtag_label_id"
                                v-model="form.customtag_label_id"
                            >
                            <div class="o-form__item">
                                <Input
                                    type="text"
                                    name="name"
                                    placeholder="Nom du tag"
                                    label="Nom du tag"
                                    v-model="form.name"
                                    required=true
                                    error-message="Ce champ est requis"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <div class="o-form__item">
                                <Input
                                    type="text"
                                    name="shortname"
                                    placeholder="Ex. CAL"
                                    label="Abréviation"
                                    v-model="form.shortname"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <div class="o-form__item -button -multiple" v-if="embedded">
                                <button type="button" class="o-button -md" :loading="$apollo.loading" color="primary" v-if="form.id && form.deleted_at"
                                    @click.stop="restoreItem(form)">
                                    Restaurer
                                    <q-icon name="save" class="o-ico -right" />
                                </button>
                                <button class="o-button -md" :loading="$apollo.loading" color="primary" v-else-if="form.id">
                                    Sauvegarder
                                    <q-icon class="o-ico" name="save" />
                                </button>
                                <button class="o-button -md" :loading="$apollo.loading" color="primary" v-if="!form.id">
                                    Ajouter
                                    <q-icon class="o-ico" name="save" />
                                </button>
                            </div>
                        </fieldset>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { CUSTOMTAGS } from '@/graphql/tag/queries'
    import { UPSERTCUSTOMTAG, DELETETAG, RESTORETAG } from '@/graphql/tag/mutations'
    import { removeNULL } from '@/js/utilities'

    export default {
        name: 'CustomTags',
        props: {
            parent_id: {
                default: null
            },
            embedded: {
                type: Boolean,
                default: false
            },
            isSmall: {
                type: Boolean,
                default: false
            }
        },
        apollo: {
            customTags: {
                query: CUSTOMTAGS,
                fetchPolicy: 'cache-and-network',
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
                update(customTags) {
                    this.listbox.listItems = Object.assign([], customTags.customTags)
                    return customTags;
                },
                variables() {
                    let variables={ trashed: this.trashed };
                    if(this.selectedParent_id!==null){
                        variables.customtag_label_id = this.selectedParent_id;
                    }
                    return variables;
                }
            },
        },
        data(){
            return {
                listbox: {
                    selectedItem: { id: -1 },
                    listItems: {},
                    addButton: 'Nouveau',
                    deleteButton: 'Supprimer',
                    copyButton: false,
                    searchable: 'Rechercher / filtrer'
                },
                form: {},
                newItem: {
                    id: 0,
                    name: null,
                },
                showDeleted: false,
            }
        },
        computed: {
            selectedParent_id () {
                this.setNewItem();
                return this.parent_id
            },
            trashed() {
                if (this.showDeleted) return 'ONLY'
                return 'WITHOUT'
            },
        },
        mounted: async function(){
            this.setNewItem();
        },
        methods: {
            setSelected(item){
                this.listbox.selectedItem = Object.assign({}, item);
                this.form=Object.assign({}, item);
            },
            setNewItem(){
                this.newItem.customtag_label_id=this.parent_id;
                this.setSelected(this.newItem);

                this.$nextTick(() => {
                    this.$eventBus.$emit('reset-validation');
                })
            },
            duplicateItem(){
                this.form.id=null;
                this.form.name=this.form.name + ' - copy'
                this.saveItem(this.form);
            },
            deleteItem(form){
                if( form.id==0 ) return this.setNewItem();

                this.$apollo.mutate({
                    mutation: DELETETAG,
                    variables: { ...form },
                    update: () => {
                        // alert('ici')
                        this.$apollo.queries.customTags.refetch()
                    }
                    // update: (store, { data: { deleteTag } }) => {
                    //     const data = store.readQuery({ query: CUSTOMTAGS })
                    //     data.customTags = data.customTags.filter(item => item.id !== deleteTag.id);
                    //     store.writeQuery({
                    //         query: CUSTOMTAGS,
                    //         data,
                    //     })
                    //     return data;
                    // }
                })
                this.setNewItem();
            },
            saveItem(form) {
                form=removeNULL(form);
                this.$apollo.mutate({
                    mutation: UPSERTCUSTOMTAG,
                    variables: { ...form },
                    update: (store, { data: { upsertCustomTag } }) => {
                        if(!form.id){
                            let myVariables={}
                            if(this.selectedParent_id) myVariables.customtag_label_id = this.selectedParent_id
                            const data = store.readQuery({
                                query: CUSTOMTAGS,
                                variables: myVariables
                            })
                            data.customTags.push(upsertCustomTag);
                            store.writeQuery({
                                query: CUSTOMTAGS,
                                data,
                                variables: myVariables
                            })
                        }
                        this.setSelected(upsertCustomTag)
                    }
                }).then(() => {
                    this.$q.notify({type: 'positive', message: "CustomTag : "+form.name, caption: "Informations sauvegardées"})
                }).catch(e => {
                    if (e.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: e.message})
                }).finally(() => {
                })
            },
            restoreItem(form) {
                this.$apollo.mutate({
                    mutation: RESTORETAG,
                    variables: {
                        id: form.id
                    },
                    update: (store, { data: { tag } }) => {
                        if (!form.id) {
                            const data = store.readQuery({ query: CUSTOMTAGS })
                            data.customTags.push(tag);
                            store.writeQuery({
                                query: CUSTOMTAGS,
                                data,
                            })
                        }
                        this.$apollo.queries.customTags.refetch()
                    }
                }).then(() => {
                    this.$q.notify({ type: 'positive', message: "Ressource : " + form.name, caption: "Informations sauvegardées" })
                }).catch(e => {
                    if (e.message) this.$q.notify({ type: 'negative', message: "Oh Oh", caption: e.message })
                }).finally(() => {
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    // .form-wrapper {
    // }
</style>
